import React, { useState } from 'react';
import { AuthConsumer } from '../lib/contexts/AuthContext';
import { Col, ToastContainer, Toast } from 'react-bootstrap';
import classNames from 'classnames';
import { EnhancementRequestModal } from './EnhancementRequest';
import { WithApiAccess } from '../lib/HigherOrderComponents/WithApiAccess';

const CurrentUser = (props) => {
  return (
		<AuthConsumer>
			{(context) => (
				<>
					<li
						className={classNames("login", props.className)}
						data-toggle={props["data-toggle"]}
						data-target={props["data-target"]}
					>
						{context.isAuthenticated() ? (
							<>
								<Col>
									<span className="currentUser">User: {context.username}</span>
									&nbsp;
									<a
										onClick={() => {
											context.logout();
										}}
										className="logout-btn"
										style={{ paddingTop: "11px", paddingBottom: "11px", marginTop: 0 }}
									>
										Logout
									</a>
								</Col>
							</>
						) : (
							<></>
						)}
					</li>
				</>
			)}
		</AuthConsumer>
	);
}

export default WithApiAccess(CurrentUser);